import type {
  PostType,
  PostTypeFacebook,
  PostTypeGoogleBusiness,
} from '../../graphqlTypes'
import {
  PostTypeEvent,
  PostTypeFacebookReel,
  PostTypeFacebookStory,
  PostTypeOffer,
  PostTypePost,
  PostTypeReel,
  PostTypeStory,
  PostTypeWhatsNew,
} from '~publish/legacy/post/constants'

// Legacy `draft.updateType` strings → GraphQL post-type enum values. The two
// value spaces diverge per network, so every mapper shares these tables
// instead of hand-rolling its own translation.

// Instagram: only `reels` diverges (GraphQL uses the singular `reel`).
const instagramPostTypes: Record<string, PostType | undefined> = {
  [PostTypePost]: 'post',
  [PostTypeReel]: 'reel',
  [PostTypeStory]: 'story',
}

// Unset or unrecognized `updateType` → `post` (the Instagram draft default).
export function mapInstagramPostType(updateType: string | null): PostType {
  return instagramPostTypes[updateType ?? ''] ?? 'post'
}

// Facebook: the post-type bar writes `facebook_reel`/`facebook_story`, not
// the generic `reels`/`story` Instagram uses — which is why this table
// exists. The generic values never occur on a Facebook draft and fall
// through to `post`.
const facebookPostTypes: Record<string, PostTypeFacebook | undefined> = {
  [PostTypePost]: 'post',
  [PostTypeFacebookReel]: 'reel',
  [PostTypeFacebookStory]: 'story',
}

export function mapFacebookPostType(
  updateType: string | null,
): PostTypeFacebook {
  return facebookPostTypes[updateType ?? ''] ?? 'post'
}

// Google Business: values match 1:1. Drafts are always constructed with
// `whats_new`, so that is the fallback.
const googleBusinessPostTypes: Record<
  string,
  PostTypeGoogleBusiness | undefined
> = {
  [PostTypeWhatsNew]: 'whats_new',
  [PostTypeOffer]: 'offer',
  [PostTypeEvent]: 'event',
}

export function mapGoogleBusinessPostType(
  updateType: string | null,
): PostTypeGoogleBusiness {
  return googleBusinessPostTypes[updateType ?? ''] ?? 'whats_new'
}
